<template>
  <div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="createDate" label="发生日期"> </el-table-column>
      <el-table-column prop="content" label="商品名称"> </el-table-column>
      <el-table-column prop="price" label="商品价格"> </el-table-column>
      <el-table-column prop="action" label="操作事项"> </el-table-column>
      <el-table-column prop="username" label="操作人"> </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: "Logs",
  data() {
    return {
      tableData: [],
    };
  },
  methods: {
    //请求日志数据
    getData() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: 'db.collection("logs").where({}).limit(1000).get()',
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.tableData = res.data.data;
        });
    },
  },
  created() {
    this.getTokens();
    //获取当前登录的用户数据
    this.getUserToken();
  },
  mounted() {
    setTimeout(() => {
      this.getData();
    }, 800);
  },
};
</script>
<style scoped></style>
